export default "__VITE_ASSET__Z0sjJSg$__"